module.exports = __webpack_public_path__ + "static/media/dashboard_dark.f63bdaf6.svg";